import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Observable, of, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ScheduleCreateService {

  constructor(public rest: RestService) { }

  createSchedule(payload: any): Observable<any> {
    return this.rest.post('createSchedule', payload);
  }

  /**
   * Upload CSV/APK for each suite in parallel (forkJoin).
   * Each suite gets its own POST with scheduleId, suiteId, useDefault* flags, and optional files.
   */
  uploadFiles(scheduleId: any, selectedSuitesForExecution: any[] = [], execApkFile?: File, suiteContainers?: Map<string, any>): Observable<any> {
    if (!selectedSuitesForExecution || selectedSuitesForExecution.length === 0) {
      return of({ results: [], failed: [] });
    }

    const uploads = selectedSuitesForExecution.map(suite => {
      const fd = new FormData();
      fd.append('scheduleId', scheduleId);
      fd.append('suiteId', suite.id);

      // Get suite-specific container if available
      const container = suiteContainers && suiteContainers.get(suite.id);
      const hasGlobalApk = !!execApkFile;

      // Determine the actual upload/default behavior from container state.
      const useDefaultCsv = container ? !!container.useDefaultCsv : true;
      const useDefaultApk = container ? (!!container.useDefaultApk && !hasGlobalApk) : !hasGlobalApk;
      const useDefaultIpa = false;

      fd.append('useDefaultCsv', useDefaultCsv ? 'true' : 'false');
      fd.append('useDefaultApk', useDefaultApk ? 'true' : 'false');
      fd.append('useDefaultIpa', useDefaultIpa ? 'true' : 'false');

      const uploadedCsv = container && container.getUploadedCsvFile ? container.getUploadedCsvFile() : null;
      if (uploadedCsv) {
        fd.append('csv', uploadedCsv, uploadedCsv.name);
      }

      if (container && container.apkFile) {
        fd.append('apk', container.apkFile, container.apkFile.name);
      } else if (execApkFile) {
        fd.append('apk', execApkFile, execApkFile.name);
      }

      return this.rest.post('uploadFile', fd).pipe(
        catchError(err => of({ error: true, err, suiteId: suite.id }))
      );
    });

    return forkJoin(uploads).pipe(
      map((results: any[]) => {
        const failed = results.filter((r: any) => r && r.error);
        return { results, failed };
      }),
      catchError(err => of({ error: true, err }))
    );
  }
}
